import { BCMSDate, BCMSDefaultModel, DisabledPrompt, useBCMSContext, BCMSStateManagerCRUD, useStateManager, BCMSRecord, StateManager, useRoute, useWorkflow } from "bcms-react";
import Classes, { Payee, User, UserAccount } from "model";
import { SVGAsset } from 'res';
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView } from "components/shared";

import "./styles.css";
import "./mobile.css";

/**
 * @function UsersTable
 * @return {React.Component}
 * @exported true
 * @description The main table component is used in UsersPage.
 */
export default function UsersTable(props) {
    const { data } = useStateManager();
    const userAccounts = data.userAccounts.map((item, index) => {
        // Time is hardcoded for now
        const minutes = index === 0 ? 0 : 30;
        item.lastLogin.time = [8, minutes, 0];
        return item;
    }, []);
    
    const rows = userAccounts.reduce((acc, account) => {
        acc.push(<UsersTableRow key={ account.id } account={ account } />);
        return acc;
    }, []);

    return (
        <TableView className="users-table">
            <TableColumnContainer>
                <TableColumnView className="text-left name-column" text="Name" icon="ArrowUpIcon" />
                <TableColumnView className="text-left user-type-column" text="User Type" />
                <TableColumnView className="text-left user-id-column" text="User ID" />
                <TableColumnView className="text-left status-column" text="Status" />
                <TableColumnView className="text-left last-login-column" text="Last Login" />
            </TableColumnContainer>
            <TableBody>{ rows }</TableBody>
        </TableView>
    )
}

/**
 * @function UsersTableRow
 * @return {React.Component}
 * @exported false
 * @description The main table row component used in UsersTableView. 
 */
function UsersTableRow(props) {
    const { data, edit } = useStateManager();
    const account = props.account ?? {};
    const accountID = account.id ?? "";
    const dataPointName = { "data-point": `Name_Label_${ accountID }`};
    const dataPointUserType = { "data-point": `User_Type_Label_${ accountID }`};
    const dataPointUserID = { "data-point": `User_ID_Label_${ accountID }`};
    const dataPointStatus = { "data-point": `Status_Label_${ accountID }`};
    const dataPointLastLogin = { "data-point": `Last_Login_Label_${ accountID }`};
    const dataPointEditIcon = { "data-point": `Edit_Icon_${ accountID }`};
    const dataPointKeyIcon = { "data-point": `Key_Icon_${ accountID }`};
    const dataPointTrashcanIcon = { "data-point": `Trashcan_Icon_${ accountID }`};
    
    const loggedInUser = data.loggedInUser;
    const isCurrentUser = loggedInUser.id === account.username

    return (
        <TableItemContainer>
            <TableItemTextView className="user-text" text={ `${ account.first } ${ account.last }`} { ...dataPointName } />
            <TableItemTextView className="user-type-text" text={ account.userType } { ...dataPointUserType } />
            <TableItemTextView className="user-id-text" text={ account.userID } { ...dataPointUserID } />
            <TableItemTextView className="status-text" text={ account.status } { ...dataPointStatus } />
            <TableItemTextView className="date-time-text" text={ account.lastLogin.format('m/d/Y h:i:s') } { ...dataPointLastLogin } />
            <TableItemView className="icon-container text-center">
                <SVGAsset id="EditIcon" className="clickable" onClick={ edit(account.id) }  { ...dataPointEditIcon } />
                <DisabledPrompt>
                    <SVGAsset id="KeyIcon" className={isCurrentUser ? `clickable hide` : `clickable`} { ...dataPointKeyIcon } />
                </DisabledPrompt>
                <DisabledPrompt>
                    <SVGAsset id="TrashcanXIcon" className={isCurrentUser ? `clickable hide` : `clickable`} { ...dataPointTrashcanIcon } />
                </DisabledPrompt>
            </TableItemView>
        </TableItemContainer>
    )
}
